export const AUDIO_VISUALIZER_TEXT_WRAPPER = 'audio-visualizer-text-wrapper';
export const DROPDOWN = 'dropdown';
export const DROPDOWN_TRIGGER = 'dropdown-trigger';
export const DROPDOWN_OPTION = 'dropdown-option';
export const MODAL_TITLE = 'title'; // used by QA
export const MODAL_MESSAGE = 'message';
export const MODAL_SHOPPING_WING_MESSAGE = 'right-wing-message';
export const MODAL_BACKDROP = 'modal-backdrop';
export const MODAL_BACK_BUTTON = 'back-button'; // used by QA
export const MODAL_CLOSE_BUTTON = 'close-button'; // used by QA
export const PROMPT_MODAL_CANCEL_BUTTON = 'prompt-modal-cancel-button'; // used by QA
export const PROMPT_MODAL_INPUT = 'prompt-modal-input'; // used by QA
export const PROMPT_MODAL_SAVE_BUTTON = 'prompt-modal-save-button'; // used by QA
export const CONFIRM_WRAPPER = 'confirm-wrapper';
export const CONFIRM_PRIMARY_BTN = 'confirm-primary-btn';
export const CONFIRM_SECONDARY_BTN = 'confirm-secondary-btn';
export const SETTING_DIALOG_MICROPHONE = 'setting-dialog-microphone';
export const SETTING_DIALOG_CAMERA = 'setting-dialog-camera';
export const SETTING_DROPDOWN_BTN = 'setting-dropdown-btn';
export const SETTING_DROPDOWN_OPTION = 'setting-dropdown-option';
export const SETTING_DROPDOWN_LABEL = 'setting-dropdown-label';
export const SPINNER = 'spinner';
export const CHIP_ICON = 'chip-icon';
export const MARQUEE = 'marquee';
export const MARQUEE_TICKER = 'marquee-ticker';
export const MARQUEE_TICKER_ITEM = 'marquee-ticker-item';
export const GRID_COLUMN = 'grid-column';
export const GRID_ROW = 'grid-row';
export const SHOWROOM_SCHEDULE_POSTER = 'showroom-schedule-poster';
export const SLOT = 'slot';
export const PRODUCT_CARD = 'product-card'; // used by QA
export const PRODUCT_CARD_ITEM_NAME = 'product-card-item-name'; // used by QA
export const PRODUCT_CARD_CAROUSEL = 'product-card-carousel';
export const PRODUCT_CARD_CAROUSEL_NAVIGATION = 'product-card-carousel-navigation';
export const PRODUCT_CARD_CAROUSEL_CHEVRON_UP_BUTTON = 'product-card-carousel-chevron-up-button';
export const PRODUCT_CARD_CAROUSEL_CHEVRON_DOWN_BUTTON = 'product-card-carousel-chevron-down-button';
export const PRODUCT_CARD_CAROUSEL_MUTE_BUTTON = 'product-card-carousel-mute-button';
export const PLAYER_DECK_PRODUCT_CARD_PRICE_WRAPPER = 'player-deck-product-card-price-wrapper';
export const PLAYER_DECK_PRODUCT_CARD_LINK = 'player-deck-product-card-link';
